import {default as Auth, Permission} from './auth';

export const getAuthorizedRegions = (regions: Array<Region>, type: Permission): Array<Region> => {
  const roles: Array<string> = Auth.getRoles();

  if (roles.some(role => role === 'admin')) {
    return regions;
  }

  const regionRoles = roles.filter(role => role.includes('regionRole'));
  const requiredRoles = regionRoles.filter(role => role.includes(type)).map(role => role.split(':')[1]);
  return regions.filter(({id}) => requiredRoles.some(role => role === id));
};



// WEBPACK FOOTER //
// ./src/utils/getAuthorizedRegions.ts